module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/client_four-d449f7382ba7ad4c418682161fc12b77.png";